/* eslint-disable no-undef */
export default {
	name: "add-edit-customer-user",
	props:{
		userId:{
			default: null
		},
		companyId:{
			default: null
		}
	},
	data() {
		return {
			customerUser:{
				userId: null,
				firstName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				lastName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				emailAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				roleId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				password: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				canViewAllOrders: {
					value: false,
					hasError: false,
					errorMessage: null
				},
				isPrimaryUser: false
			},
			loading: false,
			customerUserRoles: [],
			isUpdate: false,
			resetPassword: false,
			errorModal:{
				modalHeading: "Error",
				elementId: "customerModalError",
				modalMessage: "",
				showModal: false
			},
			successModal:{
				modalHeading: "Success",
				elementId: "customerUserModalSuccess",
				modalMessage: "",
				showModal: false
			}
		};
	},
	methods: {
		getCustomerUser(){
			let request = {
				userId: this.userId,
				companyId: this.companyId
			};
			securityService.getCustomerUser(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerUser.userId = successResponse.data.result.userId;
						this.customerUser.firstName.value = successResponse.data.result.firstName;
						this.customerUser.lastName.value = successResponse.data.result.lastName;
						this.customerUser.emailAddress.value = successResponse.data.result.email;
						this.customerUser.roleId.value = successResponse.data.result.roleId;
						this.customerUser.canViewAllOrders.value = successResponse.data.result.canViewAllOrders;
						this.customerUser.isPrimaryUser	= successResponse.data.result.isPrimaryUser;
					}
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerUserRoles(){
			// TODO: get from api
			this.customerUserRoles = [
				{
					roleId: roleHelper.role.customerAdminUser,
					role: "Customer User Admin"
				},
				{
					roleId: roleHelper.role.customerBuyer,
					role: "Buyer"
				},
				{
					roleId: roleHelper.role.customerDriver,
					role: "Driver"
				},
				{
					roleId: roleHelper.role.customerShiftSupervisor,
					role: "Shift Supervisor"
				}
			];
			this.customerUserRoles = $.map(this.customerUserRoles,
				function (obj) {
					obj.id = obj.id || obj.roleId;
					obj.text = obj.text || obj.role;
					return obj;
				});
		},
		onRoleSelect(role){
			this.customerUser.roleId.value = role.id;
		},
		onPasswordGenerated(password){
			this.customerUser.password.value = password;
		},
		onBackClick(){
			this.$router.go(-1);
		},
		validateSaveCustomerUser(){
			//TODO: validate
			this.saveCustomerUser();
		},
		saveCustomerUser(){
			//save
			this.loading = true;
			let savePassword = true;
			if(this.isUpdate && !this.resetPassword){
				savePassword = false;
			}
			console.log("companyId", this.companyId)
			let request = {
				userId: this.customerUser.userId,
				companyId: parseInt(this.companyId),
				firstName: this.customerUser.firstName.value,
				lastName: this.customerUser.lastName.value,
				email: this.customerUser.emailAddress.value,
				roleId: this.customerUser.roleId.value === null ? 0 : this.customerUser.roleId.value,
				password: this.customerUser.password.value,
				canViewAllOrders: this.customerUser.canViewAllOrders.value,
				savePassword: savePassword,
				isPrimaryUser: this.customerUser.isPrimaryUser
			};
			securityService.addOrUpdateCustomerUser(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.userValidationResponse.valuesAreValid) {
							this.successModal.showModal = true;
							this.successModal.modalHeading = "Success";
							this.successModal.modalMessage = "Customer user saved successfully";
							this.clearCustomerUserModel();
						}
						else{
							this.customerUser.firstName.hasError = successResponse.data.userValidationResponse.firstNameValidationResponse.hasError;
							this.customerUser.firstName.errorMessage = successResponse.data.userValidationResponse.firstNameValidationResponse.message;

							this.customerUser.lastName.hasError = successResponse.data.userValidationResponse.lastNameValidationResponse.hasError;
							this.customerUser.lastName.errorMessage = successResponse.data.userValidationResponse.lastNameValidationResponse.message;

							this.customerUser.emailAddress.hasError = successResponse.data.userValidationResponse.emailValidationResponse.hasError;
							this.customerUser.emailAddress.errorMessage = successResponse.data.userValidationResponse.emailValidationResponse.message;

							this.customerUser.roleId.hasError = successResponse.data.userValidationResponse.roleValidationResponse.hasError;
							this.customerUser.roleId.errorMessage = successResponse.data.userValidationResponse.roleValidationResponse.message;

							this.customerUser.password.hasError = successResponse.data.userValidationResponse.passwordValidationResponse.hasError;
							this.customerUser.password.errorMessage = successResponse.data.userValidationResponse.passwordValidationResponse.message;
						}
					}
					this.loading = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loading = false;
				}
			);
			console.log("customer", this.customerUser);
		},
		successModalOkClicked(){
			this.successModal = {
				modalHeading: "Success",
				elementId: "customerUserModalSuccess",
				modalMessage: "",
				showModal: false
			};
			if(this.isUpdate){
				this.$router.go(-1);
			}
		},
		errorModalOkClicked(){
			this.errorModal = {
				modalHeading: "Error",
				elementId: "customerModalError",
				modalMessage: "",
				showModal: false
			};
		},
		clearCustomerUserModel(){
			this.customerUser = {
				userId: null,
				firstName: {
					value: null, 
					hasError: false,	
					errorMessage: null
				},
				lastName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				emailAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				roleId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				password: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				canViewAllOrders: {
					value: false,
					hasError: false,
					errorMessage: null
				}
			};
		},
		setBreadcrumbs() {
			var pageTitle = "Add Customer User";
			console.log("companyId", this.userId);
			if(this.userId != null && this.userId > 0){
				pageTitle = "Edit Customer User";
			}
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getCustomerUserRoles();
	},
	watch: {
		userId: {
			handler: function () {
				if (this.userId !== null && this.userId > 0) {
					this.isUpdate = true;
					this.getCustomerUser();
				}
				else{
					this.isUpdate = false;
				}
			},
			immediate: true,
			deep: true
		}
	}
};